import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    Panel,
    Switch,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useValidator from "../../base/hooks/form/useValidator";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPDATE_PAYPAL_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const AppPayPalForm = ({ toolbar, app }) => {
    const { user } = useMeta();

    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "credential_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Credential Id is required.",
            },
            {
                field: "credential_secret",
                method: "isEmpty",
                validWhen: false,
                message: "This Credential Secret is required.",
            },
            {
                field: "client_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Client Id is required.",
            },
            {
                field: "test_credential_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Credential Id is required.",
            },
            {
                field: "test_credential_secret",
                method: "isEmpty",
                validWhen: false,
                message: "This Credential Secret is required.",
            },
            {
                field: "test_client_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Client Id is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                type: "Paypal",
                sandbox: inputs.sandbox === "true" || inputs.sandbox === true,
            },
        },
    };

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "PayPal",
        "",
        MUTATION_UPDATE_PAYPAL_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    const isSandbox = Boolean(inputs.sandbox);
    const clientIdField = isSandbox ? "test_client_id" : "client_id";
    const credentialIdField = isSandbox
        ? "test_credential_id"
        : "credential_id";
    const credentialSecretField = isSandbox
        ? "test_credential_secret"
        : "credential_secret";

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>PayPal</Heading>
                        <Text tone="secondary" variant="body-sm">
                            PayPal Information
                        </Text>
                    </div>
                    <div className={styles.headerActions}>
                        {toolbar ? toolbar : null}
                        <HeaderActions
                            actions={[
                                {
                                    id: "update",
                                    label: "Update",
                                    icon: loading ? undefined : <SaveIcon />,
                                    loading,
                                    disabled: loading,
                                    onClick: () => createOrUpdate(),
                                },
                            ]}
                            aria-label="PayPal actions"
                        />
                    </div>
                </div>
            }
            showHeaderDivider
        >
            <FormLayout>
                <FormLayout.Section title="Information">
                    <Switch
                        checked={isSandbox}
                        label="Sandbox"
                        name="sandbox"
                        onChange={inputChange}
                    />
                    <FormLayout.Grid columns={2} maxWidth="twoThirds">
                        <Input
                            error={fieldError(validator, clientIdField)}
                            fullWidth
                            label="Client id"
                            name={clientIdField}
                            onChange={inputChange}
                            value={inputs[clientIdField] || ""}
                        />
                        <Input
                            error={fieldError(validator, credentialIdField)}
                            fullWidth
                            label="Credential id"
                            name={credentialIdField}
                            onChange={inputChange}
                            value={inputs[credentialIdField] || ""}
                        />
                        <Input
                            error={fieldError(validator, credentialSecretField)}
                            fullWidth
                            label="Credential secret"
                            name={credentialSecretField}
                            onChange={inputChange}
                            value={inputs[credentialSecretField] || ""}
                        />
                    </FormLayout.Grid>
                </FormLayout.Section>
            </FormLayout>
        </Panel>
    );
};

export default AppPayPalForm;
